import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "subheader-icon fal fa-users" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = { class: "panel-hdr mt-2" }
const _hoisted_9 = { class: "float-left" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus-square" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-block float-right ml-1" }, "Nuevo", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "fw-300" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-collapse",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Collapse"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-fullscreen",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Fullscreen"
  })
], -1)
const _hoisted_15 = { class: "panel-container" }
const _hoisted_16 = { class: "panel-content" }
const _hoisted_17 = { class: "row mb-1" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "nombre"
}, "Presentación", -1)
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = { class: "input-group-append" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" }, null, -1)
const _hoisted_24 = { class: "col-xl-12" }
const _hoisted_25 = {
  id: "panel-listado",
  class: "panel"
}
const _hoisted_26 = { class: "panel-hdr mt-2" }
const _hoisted_27 = { class: "fw-300" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-collapse",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Collapse"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-fullscreen",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Fullscreen"
  })
], -1)
const _hoisted_29 = { class: "panel-container" }
const _hoisted_30 = { class: "panel-content" }
const _hoisted_31 = { class: "row mb-2" }
const _hoisted_32 = { class: "col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "input-group" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" })
  ])
], -1)
const _hoisted_36 = { class: "custom-control custom-checkbox ml-3" }
const _hoisted_37 = ["id", "name", "checked"]
const _hoisted_38 = ["for"]
const _hoisted_39 = { class: "input-group-append" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-edit" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-content-overlay",
  "data-action": "toggle",
  "data-class": "mobile-nav-on"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_presentacion_editar_component = _resolveComponent("presentacion-editar-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm mr-2",
                  title: "Nuevo",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.nuevaPresentacion && $setup.nuevaPresentacion(...args)))
                }, _hoisted_12)
              ]),
              _createElementVNode("h2", null, [
                _createTextVNode(" Filtro de"),
                _createElementVNode("span", _hoisted_13, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
                ])
              ]),
              _hoisted_14
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "nombre",
                          name: "nombre",
                          class: "form-control form-control-sm",
                          placeholder: "Nombre presentación",
                          autocomplete: "off",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.fitroBusqueda.textoBuscar) = $event)),
                          onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => ($setup.buscarPresentaciones && $setup.buscarPresentaciones(...args)), ["enter"]))
                        }, null, 544), [
                          [
                            _vModelText,
                            $setup.fitroBusqueda.textoBuscar,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("button", {
                            class: "btn btn-primary btn-sm mb-2",
                            id: "btn-buscar-presentaciones",
                            name: "btn-buscar-presentaciones",
                            type: "button",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.buscarPresentaciones && $setup.buscarPresentaciones(...args)))
                          }, [
                            _hoisted_23,
                            _createTextVNode(" Buscar ")
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("h2", null, [
                _createTextVNode(" Listado de"),
                _createElementVNode("span", _hoisted_27, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
                ])
              ]),
              _hoisted_28
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "texto-buscar",
                          name: "texto-buscar",
                          class: "form-control form-control-sm flex",
                          placeholder: "Buscar",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.textoFiltro) = $event)),
                          onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.filtrarInformacion && $setup.filtrarInformacion(...args)))
                        }, null, 544), [
                          [_vModelText, $setup.textoFiltro]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_EasyDataTable, {
                  headers: $setup.headers,
                  items: $setup.presentacionesFiltrados,
                  "border-cell": "",
                  alternating: "",
                  "buttons-pagination": ""
                }, {
                  "item-estado": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "custom-control-input",
                        id: 'estado' + item.id_categoria,
                        name: 'estado' + item.id_categoria,
                        checked: item.estado
                      }, null, 8, _hoisted_37),
                      _createElementVNode("label", {
                        class: "custom-control-label",
                        for: 'estado_' + item.id_categoria
                      }, null, 8, _hoisted_38)
                    ])
                  ]),
                  "item-acciones": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary btn-xs",
                        title: "Editar presentación",
                        onClick: ($event: any) => ($setup.editarPresentacion(item))
                      }, _hoisted_42, 8, _hoisted_40)
                    ])
                  ]),
                  _: 1
                }, 8, ["headers", "items"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_43,
    _createVNode(_component_presentacion_editar_component, {
      ref: "presentacionEditarComponentRef",
      onCerrarEditarPresentacionComponent: $setup.cerrarEditarPresentacionComponentEmit
    }, null, 8, ["onCerrarEditarPresentacionComponent"])
  ], 64))
}